'use client';

import React from 'react';
import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';

// Backend integration point: GET /api/ehs/moc/status-summary
const mocData = [
  { id: 'moc-approved', name: 'Approved', value: 14, color: '#22c55e' },
  { id: 'moc-review', name: 'Under Review', value: 9, color: '#f59e0b' },
  { id: 'moc-draft', name: 'Draft', value: 5, color: '#64748b' },
  { id: 'moc-overdue', name: 'Overdue', value: 3, color: '#ef4444' },
  { id: 'moc-implemented', name: 'Implemented', value: 22, color: '#8b5cf6' },
];

const total = mocData.reduce((s, d) => s + d.value, 0);

const CustomTooltip = ({ active, payload }: any) => {
  if (!active || !payload?.length) return null;
  const d = payload[0].payload;
  return (
    <div className="bg-[hsl(var(--card))] border border-[hsl(var(--border))] rounded-lg px-3 py-2 shadow-xl text-xs">
      <p className="font-600 text-[hsl(var(--foreground))]">{d.name}</p>
      <p className="text-[hsl(var(--muted-foreground))]">
        {d.value} items ({((d.value / total) * 100).toFixed(1)}%)
      </p>
    </div>
  );
};

export default function MOCStatusDonut() {
  return (
    <div className="bg-[hsl(var(--card))] border border-[hsl(var(--border))] rounded-xl p-5 h-full flex flex-col">
      <div className="mb-3">
        <h3 className="text-sm font-600 text-[hsl(var(--foreground))]">MOC Pipeline Status</h3>
        <p className="text-xs text-[hsl(var(--muted-foreground))] mt-0.5">
          {total} total change requests · Q2 2026
        </p>
      </div>

      <div className="relative flex-1 min-h-[180px]">
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={mocData}
              cx="50%"
              cy="50%"
              innerRadius="55%"
              outerRadius="80%"
              paddingAngle={2}
              dataKey="value"
            >
              {mocData.map((entry) => (
                <Cell key={entry.id} fill={entry.color} fillOpacity={0.9} stroke="none" />
              ))}
            </Pie>
            <Tooltip content={<CustomTooltip />} />
          </PieChart>
        </ResponsiveContainer>
        {/* Center label */}
        <div className="absolute inset-0 flex flex-col items-center justify-center pointer-events-none">
          <span className="text-2xl font-700 tabular-nums text-[hsl(var(--foreground))]">{total}</span>
          <span className="text-[10px] text-[hsl(var(--muted-foreground))] uppercase tracking-wide">MOC Items</span>
        </div>
      </div>

      {/* Legend */}
      <div className="grid grid-cols-2 gap-x-3 gap-y-2 mt-3">
        {mocData.map((item) => (
          <div key={`legend-${item.id}`} className="flex items-center gap-1.5">
            <span className="w-2 h-2 rounded-full shrink-0" style={{ backgroundColor: item.color }} />
            <span className="text-[11px] text-[hsl(var(--muted-foreground))] truncate">{item.name}</span>
            <span className="text-[11px] font-600 tabular-nums ml-auto text-[hsl(var(--foreground))]">{item.value}</span>
          </div>
        ))}
      </div>
    </div>
  );
}